import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const AuthPropTypes = PropTypes.shape({
    identifier: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
});

export const AuthDefaultProps = {
    identifier: '',
    password: '',
};

export const AuthYupSchema = Yup.object().shape({
    identifier: Yup.string().required('Required'),
    password: Yup.string().required('Required'),
});

export default {
    AuthDefaultProps,
    AuthPropTypes,
    AuthYupSchema,
};
